import React from 'react';
import { Helmet } from 'react-helmet-async';
import Services from './Services';

const OurServices: React.FC = () => {
  return (
    <div>
      <Helmet>
        <title>Real Estate Consulting Services, Branding, Marketing, Sales</title>
        <meta name="description" content="Explore our strategic real estate consulting services, results oriented, tech driven custom solutions aimed at maximizing your ROI" />
        <meta name="keywords" content="real estate consultant near me, property consultant near me, real estate consulting companies, real estate advisory, real estate consulting firms, real estate consulting services, real estate marketing consultant" />
      </Helmet>
      <Services />
    </div>
  );
};

export default OurServices;
